import React from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { FieldGroup, FormField } from 'components/formKit'
import type { FONT_BASE_FIELDS } from 'services/Branding/fieldConfigs'

export interface IDefaultBaseFontFormProps {
  font: typeof FONT_BASE_FIELDS
  children?: React.ReactNode
}

const DefaultBaseFontForm: React.FC<IDefaultBaseFontFormProps> = ({ font, children }) => {
  return (
    <Padding gap sides>
      {children}
      <FormField config={font.fontFamily} />
      <FieldGroup config={font.fontStyleGroup}>
        <FormField config={font.fontWeight} />
        <FormField config={font.fontStyle} />
      </FieldGroup>
      <FormField config={font.fontSize} />
      <FormField config={font.lineHeight} />
      <FormField config={font.color} />
    </Padding>
  )
}

export default DefaultBaseFontForm
